<template>
	<div class="clearfix" style="width: 80%;margin: 50px auto;">
		<el-form ref="form" :model="form" label-width="120px" :rules="rules" style="text-align: left;float: left;width: 60%;padding-right: 40px;">
			<el-form-item label="logo图标：" prop="name">
				<el-upload
					class="upload-avatar fl"
					action=""
					:on-remove="handlePosterRemove"
					:on-success="handlePosterSuccess"
					list-type="picture"
					:on-change="getPosterChange"
					:file-list="fileList"
					:auto-upload='false'
				>
					<el-button size="middle" type="primary">选择图片</el-button>
					<div slot="tip" class="el-upload__tip" style="margin-left: 20px;">
						<i class="el-icon-warning"></i>
						建议上传200x200的方形logo
					</div>
				</el-upload>
			</el-form-item>
			<!-- <el-form-item > -->
			<div class="logoImg"><img :src="imgUrl" /></div>
			<!-- </el-form-item> -->
			<el-form-item label="logo启用：" prop="idtype">
				<!-- <el-radio v-model="radio" label="0">是</el-radio>
				  <el-radio v-model="radio" label="1">否</el-radio> -->
				<el-radio-group v-model="radio">
					<el-radio :label="1">是</el-radio>
					<el-radio :label="0">否</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="码图颜色：" prop="Unifiedsocialcredit">
				<el-color-picker v-model="color" @change="onColorChange" :predefine="predefineColors"></el-color-picker>
				<span style="line-height: 40px;color: #666;font-size: 12px;vertical-align: top;margin-left: 20px;">
					<i class="el-icon-warning"></i>
					仅QR码有效,系统默认颜色: #003f9a
				</span>
			</el-form-item>
			<el-form-item label="边框样式：" prop="borderStyle">
				<el-select v-model="borderStyle" placeholder="请选择" size="mini" @change="styleChange">
					<el-option v-for="(item, index) in borderList" :key="index" :label="item.borderName" :value="item.borderValue"></el-option>
				</el-select>
				<!-- <el-select v-model="borderColr" placeholder="请选择" size="mini">
					<el-option v-for="(item, index) in borderSize" :key="index" :label="item.borderName" :value="item.borderValue"></el-option>
				</el-select> -->
			</el-form-item>
			<el-form-item label="码图尺寸：" prop="Unifiedsocialcredit">
				<el-select v-model="mask" placeholder="请选择" size="mini">
					<el-option v-for="(item, index) in QRSize" :key="index" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<span style="line-height: 40px;color: #666;font-size: 12px;vertical-align: top;margin-left: 20px;">
					<i class="el-icon-warning"></i>
					括号中尺寸为实际图片尺寸
				</span>
			</el-form-item>
			<el-button type="primary" style="margin: 0 auto;display: block;" @click="preser()">保存</el-button>
		</el-form>
		<div class="fl" style="border-left: 1px solid #e6e6e6;">
			<div class="matu-yulan">
				<div class="matuyulan-cont">
					<div class="matu" id="imgDiv">
						<!-- <img id="img1" style="position: absolute; top: 11px; left: 11px; z-index: 1; display: none;" src="/static/Images/YuLan/catecode.jpg" /> scode -->
						<img id="img1" src="../assets/imgs/scode.jpg" />
						<img id="img2" style="display: none;" src="/static/Images/YuLan/ccode.jpg" />
						<img id="img3" style="display: none;" src="/static/Images/YuLan/code.jpg" />
						<img id="img4" style="display: none;" width="25px" height="25px" src="/static/Images/YuLan/logo.jpg" />
						<img id="img5" style="display: none;" src="/static/Images/YuLan/scode.jpg" />
						<img id="img5-1" style="display: none;" src="/static/Images/YuLan/scode1.jpg" />
						<img id="img5-2" style="display: none;" src="/static/Images/YuLan/scode2.jpg" />
						<img id="img5-3" style="display: none;" src="/static/Images/YuLan/scode3.jpg" />
						<img id="img5-4" style="display: none;" src="/static/Images/YuLan/scode4.jpg" />
						<img id="img5-5" style="display: none;" src="/static/Images/YuLan/scode5.jpg" />
						<img id="img6" style="display: none;" src="/static/Images/YuLan/renzheng1.jpg" />
					</div>
				</div>
				<div style="line-height: 2;"><strong>码标码</strong></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'personalCard',
	data() {
		return {
			radio: 0,
			color: '',
			predefineColors: [
				'#ff4500',
				'#ff8c00',
				'#ffd700',
				'#90ee90',
				'#00ced1',
				'#1e90ff',
				'#c71585',
				'rgba(255, 69, 0, 0.68)',
				'rgb(255, 120, 0)',
				'hsv(51, 100, 98)',
				'hsva(120, 40, 94, 0.5)',
				'hsl(181, 100%, 37%)',
				'hsla(209, 100%, 56%, 0.73)',
				'#c7158577'
			],
			form: {},
			fileList: [],
			rules: {},
			codeimagesize: '',
			QRSize: [
				{
					id: 3,
					name: '小图(3CM)'
				},
				{
					id: 5,
					name: '中图(5CM)'
				},
				{
					id: 10,
					name: '大图(10CM)'
				}
			],
			borderSize: [],
			borderStyle: '',
			borderList: [],
			mask: '',
			borderColr: 203,
			imgUrl: ''
		};
	},
	computed: {},
	mounted() {
		this.$store.commit('resistopen');
		//           this.$store.state.resistshow =true;
		//			console.log(this.$store.state.resistshow )
	},
	created() {
		var color = localStorage.getItem('color');
		if (color) {
			this.color = color;
		}
		this.QR();
	},
	methods: {
		QR() {
			// 获取边框列表
			this.$http.get(this.$api + '/CodeImage/getBorderType', {}).then(
				res => {
					console.log('获取边框列表');
					console.log(res);
					this.borderList = [];
					if (res.body.hasOwnProperty('entity')) {
						this.borderList = res.body.entity;
						if (res.body.entity.length != 0) {
							this.borderStyle = res.body.entity[0].borderValue;
							this.borderSize = res.body.entity[0].childList;
							if (res.body.entity[0].childList.length != 0) {
								this.borderColr = res.body.entity[0].childList[0].borderValue;
							}
						}
					}
				},
				rej => {}
			);
			// 获取码图样式设置
			this.$http.get(this.$api + '/CodeImage/getCodeImageSet', {}).then(
				res => {
					console.log('获取码图样式设置');
					console.log(res);
					if (res.body.hasOwnProperty('entity')) {
						this.imgUrl = res.body.entity.interimage;
						this.mask = res.body.entity.codeimagesize;
						this.color = '#' + res.body.entity.codeimagecolor;
						console.log(this.color, '颜色');
						this.radio = res.body.entity.interimageset;
					}
				},
				rej => {}
			);
		},
		// 边框样式选择框第一个选择框change函数
		styleChange(value) {
			var len = this.borderList.length;
			for (let i = 0; i < len; i++) {
				let val = this.borderList[i];
				if (this.borderStyle == val.borderValue) {
					this.borderSize = val.childList;
				}
			}
		},
		// 图码颜色设置
		onColorChange(val) {
			console.log('颜色选择');
			console.log(val);
			this.color = val;
			localStorage.setItem('color', val);
		},
		// 图片移除
		handlePosterRemove() {},
		//  图片上传
		getPosterChange(file, fileList) {
			this.fileList = fileList;
			var data = new FormData();
			data.append('file', file.raw);
			this.$http.post(this.$api + '/upload/uploadImageFile', data).then(
				res => {
					console.log('数据上传');
					console.log(res);
					this.imgUrl = '';
					if (res.body.hasOwnProperty('entity')) {
						if (res.body.entity.hasOwnProperty('imageUrl') && res.body.entity.hasOwnProperty('imageBig')) {
							this.imgUrl = res.body.entity.imageUrl + res.body.entity.imageBig;
							console.log(this.imgUrl, '图片拼接地址更换');
							this.$message({
								showClose: true,
								message: '图片上传成功',
								type: 'success'
							});
							this.$forceUpdate();
						}
					}
				},
				rej => {}
			);
		},
		// 图片上传成功
		handlePosterSuccess() {},
		// 保存
		preser() {
			var params = {
				bordertype: 20, // 边框样式一级，固定值：20
				bordertypemb: 203, //边框样式二级，固定值：203
				interimage: this.imgUrl, //logo图标
				interimageset: this.radio, //是否启用logo 1 启用 0 不启用
				codeimagecolor: this.color.substring(1), // 码图颜色
				codeimagesize: this.mask //码图尺寸  3 小图(3CM)   5 小图(5CM)  10 小图(10CM)
			};
			this.$http.post(this.$api + '/CodeImage/saveCodeImgSet', JSON.stringify(params)).then(
				res => {
					console.log('获取边框列表');
					console.log(res);
					if (res.body.result === 1) {
						this.$message({
							showClose: true,
							message: '保存成功',
							type: 'success'
						});
					}
				},
				rej => {}
			);
		}
	},
	destroyed() {
		//console.log(this.$store.state.resistshow )
		this.$store.commit('resistDestroy');
		localStorage.setItem('color', '');
	}
};
</script>

<style lang="scss">
.result-box {
	.el-table {
		.cell {
			text-align: center;
		}
	}
}

.matu-yulan .matu {
	width: 180px;
	height: 180px;
	border: 1px solid #e6e6e6;
	text-align: center;
	vertical-align: middle;
	padding: 10px;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;

	img {
		width: 100%;
		height: auto;
		object-fit: scale-down;
	}
}

.matu-yulan {
	width: 200px;
	margin-top: 100px;
	margin-left: 40px;
}

.matuyulan-cont p {
	margin-top: 20px;
	text-align: center;
}
.logoImg {
	display: block;
	width: 110px;
	height: 110px;
	margin-left: 115px;
	border: 1px solid #e6e6e6;
	justify-content: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	display: flex;
}
.logoImg img {
	width: 100px;
	height: auto;
	object-fit: fill;
	//  margin-left: 115px;
}
</style>
